import { Box } from '@hermes/web-components'
import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { HomePageContext } from '../../../../providers/HomePage'
import { HomePageViewProps } from '../../../SearchPage/common/types'
import { StartSearchButton, StartSearchText } from './styles'
import MobileFiltersModal from '../MobileFiltersModal'
import useHomePageSearchBarConfig from 'components/search/hooks/useHomePageSearchBarConfig'
import useTranslateMessage from '../../../../hooks/useTranslateMessage'

const MobileView = ({
  onSearchFieldFocus,
  onChangeLocationSearch,
  onChangeSearchType,
  setIsLocationFieldFocused,
  onChangeSearch,
  onSearchFieldBlur,
  getYourLocation,
  setIsSearchFieldFocused,
  isSearchFieldFocused,
  handleSearch
}: HomePageViewProps) => {
  const {
    state: { isKeywordChanged }
  } = useContext(HomePageContext)
  const searchTriggerRef = useRef<HTMLDivElement>()
  const translate = useTranslateMessage()

  const { MobileKeywordSearchLeftIconAlternative } = useHomePageSearchBarConfig()

  const [searchBarExpand, setSearchBarExpand] = useState(false)

  const [searchText, setSearchText] = useState('')

  const expandSearchBar = () => {
    setSearchBarExpand(true)

    // NOTE: Fixes iOS Safari bug where input jumps on first focus by locking scroll and manually positioning
    if (searchTriggerRef.current) {
      window.scroll(0, searchTriggerRef.current.offsetTop)
    }
  }

  useEffect(() => {
    if (searchBarExpand) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [searchBarExpand])

  const onSearch = useCallback(() => {
    handleSearch()
    document.body.style.overflow = 'auto'
  }, [handleSearch])

  return (
    <Box>
      {searchBarExpand ? (
        <MobileFiltersModal
          setSearchBarExpand={setSearchBarExpand}
          isSearchFieldFocused={isSearchFieldFocused}
          setIsSearchFieldFocused={setIsSearchFieldFocused}
          onChangeSearch={onChangeSearch}
          onSearchFieldBlur={onSearchFieldBlur}
          onChangeLocationSearch={onChangeLocationSearch}
          onSearch={onSearch}
          onChangeSearchType={onChangeSearchType}
          getYourLocation={getYourLocation}
          setIsLocationFieldFocused={setIsLocationFieldFocused}
          onSearchFieldFocus={onSearchFieldFocus}
          setSearchText={setSearchText}
          searchText={searchText}
        />
      ) : (
        <StartSearchButton
          ref={searchTriggerRef}
          onClick={() => {
            if (!isKeywordChanged) {
              expandSearchBar()
            }
          }}
        >
          <MobileKeywordSearchLeftIconAlternative
            sx={{ color: '#2247B3', path: { stroke: '#2247B3' }, width: '16px', height: '16px' }}
          />
          <StartSearchText>{translate('homepage.search.start')}</StartSearchText>
        </StartSearchButton>
      )}
    </Box>
  )
}

export default MobileView
